/**
 * 구독 관리 페이지 라우트
 * FSD: pages/subscription-manage
 */

import { RouteObject } from 'react-router-dom';
import SubscriptionManagePage from './ui/SubscriptionManagePage';

export const subscriptionManageRoute: RouteObject = {
  path: '/subscription/manage',
  element: <SubscriptionManagePage />,
};
